// 账号密码
import React from 'react';
import { Form, Input } from 'antd';
import MD5 from 'crypto-js/md5';
import intl from 'react-intl-universal';

import IconFont from '@/components/IconFont';

import SubmitButton from '../SubmitButton';

import styles from './index.module.scss';

const Index = (props) => {
  const [formField] = Form.useForm();

  // 提交登录
  const handleSubmit = async () => {
    try {
      const { username, password } = await formField.validateFields();
      props.onSubmit({ username, code: MD5(password).toString() });
    } catch (_) {
      //
    }
  };

  return (
    <div className={styles.formWrapper}>
      <Form form={formField}>
        <Form.Item
          name="username"
          rules={[{ required: true, message: intl.get('login_form_account_message') }]}
        >
          <Input
            prefix={<IconFont type="icon-zhanghao" />}
            allowClear
            placeholder={intl.get('login_form_account_placeholder')}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: intl.get('login_form_password_message') }]}
        >
          <Input
            prefix={<IconFont type="icon-mima" />}
            allowClear
            placeholder={intl.get('login_form_password_placeholder')}
            type="password"
          />
        </Form.Item>
        <SubmitButton onClick={handleSubmit} />
      </Form>
    </div>
  );
};

export default Index;
